<template>
  <!--Main Slider-->
  <section id="main-banner-area" class="position-relative">
    <div class="slider">
      <div class="list">
        <!-- Dynamic slider items -->
      </div>
    </div>

    <div
      class="tp-bullets numbered vertical nav-pos-hor-left nav-pos-ver-center nav-dir-vertical white"
      style="
        height: 55px;
        width: 15.3167px;
        top: 50%;
        transform: matrix(1, 0, 0, 1, 20, -27);
        left: 0px;
      "
    >
      <!-- Dynamic pagination bullets -->
    </div>
    <ul class="social-icons-simple revicon white">
      <li class="d-table" v-for="(item, index) in listSocialMedia" :key="index">
        <a :href="item.url" class=""><i :class="item.icon"></i></a>
      </li>
    </ul>
  </section>
  <!--Main Slider ends -->

  <!--Some Feature -->
  <section id="about" class="single-feature padding mt-n5">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <!-- <div id="about-slider" class="owl-carousel">
            <div class="item"> -->
          <div class="row d-flex align-items-center">
            <div
              class="col-lg-6 text-sm-left text-center wow fadeInLeft"
              data-wow-delay="300ms"
            >
              <div class="heading-title mb-4">
                <h2 class="darkcolor font-normal bottom30">
                  <span class="defaultcolor"> Keterangan Umum </span>
                  <br />
                  Permohonan Surat Keterangan
                </h2>
              </div>
              <p class="bottom35">
                Kewajiban Perizinan Berusaha penyediaan tenaga listrik untuk
                kepentingan sendiri dengan total kapasitas pembangkit tenaga
                listrik sampai dengan 50O kW (lima ratus kilowatt) yang
                terhubung dalam 1 (satu) sistem Instalasi Tenaga Listrik berupa
                penyampaian laporan sebanyak I (satu) kali kepada Menteri atau
                gubernur sebelum melakukan Usaha Penyediaan Tenaga Listrik untuk
                kepentingan sendiri.
              </p>
              <!-- <a
                href="javascript:void(0)"
                class="button gradient-btn bg-custom mb-sm-0 mb-4"
                >Baca Selengkapnya</a
              > -->
            </div>
            <div class="col-lg-6 wow fadeInRight" data-wow-delay="300ms">
              <div class="image float-right">
                <img alt="" src="images/bg-about.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div>
    </div> -->
  </section>
  <!--Some Feature ends-->

  <!-- Counters -->
  <section id="bg-counters" class="padding bg-counters parallax">
    <div class="container">
      <div class="row align-items-center text-center">
        <div class="overlay overlay-dark opacity-1 z-index-0"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 bottom10">
          <div class="container">
            <div class="row text-center justify-content-center mb-5">
              <div class="col-xl-6 col-lg-8">
                <h3 class="font-weight-bold text-white">Alur Proses</h3>
                <p class="text-white">Permohonan Dukungan Daya</p>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div
                  class="timeline-steps aos-init aos-animate"
                  data-aos="fade-up"
                >
                  <div class="timeline-step text-white">
                    <div
                      class="timeline-content"
                      data-toggle="popover"
                      data-trigger="hover"
                      data-placement="top"
                      title=""
                      data-content="And here's some amazing content. It's very engaging. Right?"
                      data-original-title="2003"
                    >
                      <div class="inner-circle"></div>
                      <p class="h5 mt-3 mb-1">1</p>
                      <p class="h5 text-white mb-0 mb-lg-0">
                        Pengajuan Permohonan
                      </p>
                    </div>
                  </div>
                  <div class="timeline-step text-white">
                    <div
                      class="timeline-content"
                      data-toggle="popover"
                      data-trigger="hover"
                      data-placement="top"
                      title=""
                      data-content="And here's some amazing content. It's very engaging. Right?"
                      data-original-title="2004"
                    >
                      <div class="inner-circle"></div>
                      <p class="h5 mt-3 mb-1">2</p>
                      <p class="h5 text-white mb-0 mb-lg-0">
                        Verifikasi Verifikator
                      </p>
                    </div>
                  </div>
                  <div class="timeline-step text-white">
                    <div
                      class="timeline-content"
                      data-toggle="popover"
                      data-trigger="hover"
                      data-placement="top"
                      title=""
                      data-content="And here's some amazing content. It's very engaging. Right?"
                      data-original-title="2005"
                    >
                      <div class="inner-circle"></div>
                      <p class="h5 mt-3 mb-1">3</p>
                      <p class="h5 text-white mb-0 mb-lg-0">Verifikasi Kabid</p>
                    </div>
                  </div>
                  <div class="timeline-step text-white">
                    <div
                      class="timeline-content"
                      data-toggle="popover"
                      data-trigger="hover"
                      data-placement="top"
                      title=""
                      data-content="And here's some amazing content. It's very engaging. Right?"
                      data-original-title="2005"
                    >
                      <div class="inner-circle"></div>
                      <p class="h5 mt-3 mb-1">4</p>
                      <p class="h5 text-white mb-0 mb-lg-0">
                        Verifikasi Kadis & TTE Kadis
                      </p>
                    </div>
                  </div>
                  <div class="timeline-step text-white">
                    <div
                      class="timeline-content"
                      data-toggle="popover"
                      data-trigger="hover"
                      data-placement="top"
                      title=""
                      data-content="And here's some amazing content. It's very engaging. Right?"
                      data-original-title="2005"
                    >
                      <div class="inner-circle"></div>
                      <p class="h5 mt-3 mb-1">5</p>
                      <p class="h5 text-white mb-0 mb-lg-0">Selesai</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Counters ends-->

  <section
    id="our-blog"
    class="bglight padding_top padding_bottom_half"
    style="
      background-image: url('fe/asset/img/big-bg-white.png');
      background-size: cover;
      border-radius: 10px !important;
    "
  >
    <b-overlay :show="false" rounded="sm">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="news_item shadow-equal">
              <div
                class="news_desc text-center text-md-left"
                style="
                  background-color: #fff !important;
                  background-image: none !important;
                "
              >
                <div class="mt-0 mb-5">
                  <h4 class="text-dark">Dasar Hukum</h4>
                </div>

                <div class="mt-5">
                  <div class="row">
                    <div class="col-md-4">
                      <input
                        type="text"
                        v-model="search"
                        v-debounce:200ms="searchItems"
                        class="form-control form-control-solid w-250px ps-15"
                        placeholder="Cari..."
                      />
                    </div>
                    <div class="col-md-4">
                      <!-- <select
                        name=""
                        class="form-control"
                        @change="handleCategoryChange($event)"
                      >
                        <option value="">Semua Kategori</option>
                        <option
                          v-for="item in rulesCategoryList"
                          :key="item"
                          :value="item.id"
                        >
                          {{ item.name }}
                        </option>
                      </select> -->
                    </div>
                    <div class="col-md-4">
                      <select
                        name=""
                        class="form-control"
                        @change="handleTahunChange($event)"
                      >
                        <option value="">Semua Tahun</option>
                        <option
                          v-for="item in listTahun"
                          :key="item"
                          :value="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <Datatable
                    @on-sort="sort"
                    @on-items-per-page-change="itemsPerPageChange"
                    @page-change="pageChange"
                    :data="rulesList"
                    :header="tableHeader"
                    :enable-items-per-page-dropdown="true"
                    :total="rulesMeta.total_data"
                    :itemsPerPage="10"
                    empty-table-text="Tidak ada data"
                  >
                    <template v-slot:id="{ row }">
                      {{
                        rulesList.indexOf(row) +
                        1 +
                        (rulesMeta.page - 1) * rulesMeta.limit
                      }}.
                    </template>
                    <template v-slot:tahun_terbit="{ row: rulesList }">
                      {{ rulesList.tahun_terbit }}
                    </template>
                    <!-- <template v-slot:category_id="{ row: rulesList }">
                      {{ rulesList.category.name }}
                    </template> -->
                    <template v-slot:title="{ row: rulesList }">
                      {{ rulesList.title }}
                    </template>
                    <template v-slot:actions="{ row: rulesList }">
                      <a
                        target="_blank"
                        :href="getFilePath('rules-doc', rulesList.document)"
                        class="btn btn-sm btn-secondary"
                      >
                        <i class="bi bi-file-earmark-arrow-down-fill"></i>
                        Download PDF
                      </a>
                    </template>
                  </Datatable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </section>
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, onMounted, reactive, ref } from "vue";
import { useCmsStores } from "@/store/cms";
import { getFilePath } from "@/core/helpers/assets";
import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src
import { fomatDateTimeIndo } from "@/core/helpers/date";
import Datatable from "@/components/kt-datatable/KTDataTable.vue";
import { Sort } from "@/components/kt-datatable/table-partials/models";

export default defineComponent({
  name: "HomeView",
  components: {
    HelloWorld,
    Datatable,
  },
  setup() {
    const cmsStore = useCmsStores();
    const loadingGallery = ref(false);
    const isLoading = ref(false);

    const tableHeader = ref([
      {
        columnName: "No",
        columnLabel: "id",
        sortEnabled: true,
        columnWidth: 40,
      },
      {
        columnName: "Tahun",
        columnLabel: "tahun_terbit",
        sortEnabled: true,
        columnWidth: 100,
      },
      // {
      //   columnName: "Kategori",
      //   columnLabel: "category_id",
      //   sortEnabled: false,
      //   columnWidth: 175,
      // },
      {
        columnName: "Judul",
        columnLabel: "title",
        sortEnabled: true,
        columnWidth: 300,
      },
      {
        columnName: "Aksi",
        columnLabel: "actions",
        sortEnabled: false,
        columnWidth: 60,
      },
    ]);

    const rulesList = ref([]);
    const rulesMeta = reactive({
      limit: 10,
      offset: 0,
      page: 1,
      total_data: 0,
    });

    const sliderData = [
      {
        title: "Permohonan Surat Keterangan",
        description:
          "Kewajiban Perizinan Berusaha penyediaan tenaga listrik untuk kepentingan sendiri dengan total kapasitas pembangkit tenaga listrik sampai dengan 50O kW (lima ratus kilowatt) yang terhubung dalam 1 (satu) sistem Instalasi Tenaga Listrik berupa penyampaian laporan sebanyak I (satu) kali kepada Menteri atau gubernur sebelum melakukan Usaha Penyediaan Tenaga Listrik untuk kepentingan sendiri.",
        image: "images/slider/bundaran-hi.png",
      },
    ];

    const renderSlider = () => {
      const sliderList = document.querySelector(".slider .list");
      const pagination = document.querySelector(".tp-bullets");

      sliderData.forEach((item, index) => {
        const sliderItem = document.createElement("div");
        sliderItem.classList.add("item");
        if (index === 0) {
          sliderItem.classList.add("active");
        }

        const img = document.createElement("img");
        img.src = item.image;
        img.alt = item.title;

        const content = document.createElement("div");
        content.classList.add("content");

        const h2 = document.createElement("h2");
        h2.textContent = item.title;

        const p = document.createElement("p");
        p.textContent = item.description;

        content.appendChild(h2);
        content.appendChild(p);

        sliderItem.appendChild(img);
        sliderItem.appendChild(content);

        sliderList.appendChild(sliderItem);

        // Create pagination bullets
        const bullet = document.createElement("div");
        bullet.classList.add("tp-bullet");
        if (index === 0) {
          bullet.classList.add("selected");
        } else {
          bullet.style.top = `${index * 10}px`;
          bullet.style.left = "0px";
        }

        const bulletNumber = document.createElement("div");
        bulletNumber.classList.add("tp-bullet-number");

        if (index < 9) {
          bulletNumber.innerHTML = `<span class="tp-count">0${
            index + 1
          }</span><span class="tp-bullet-line"></span>`;
        } else {
          bulletNumber.innerHTML = `<span class="tp-count">${
            index + 1
          }</span><span class="tp-bullet-line"></span>`;
        }

        bullet.appendChild(bulletNumber);
        pagination.appendChild(bullet);
      });

      // Slider functionality
      const items = document.querySelectorAll(".slider .list .item");
      const paginationItems = document.querySelectorAll(
        ".tp-bullets .tp-bullet"
      );

      let currentIndex = 0;
      let interval = setInterval(() => {
        currentIndex++;
        if (currentIndex > items.length - 1) {
          currentIndex = 0;
        }
        changeSlide(currentIndex);
      }, 5000);

      function changeSlide(index) {
        items.forEach((item, i) => {
          if (i === index) {
            item.classList.add("active");
          } else {
            item.classList.remove("active");
          }
        });

        paginationItems.forEach((item, i) => {
          if (i === index) {
            item.classList.add("selected");
          } else {
            item.classList.remove("selected");
          }
        });
      }

      paginationItems.forEach((item, i) => {
        item.addEventListener("click", () => {
          clearInterval(interval);
          changeSlide(i);
          currentIndex = i;
          interval = setInterval(() => {
            currentIndex++;
            if (currentIndex > items.length - 1) {
              currentIndex = 0;
            }
            changeSlide(currentIndex);
          }, 5000);
        });
      });
    };

    onMounted(async () => {
      renderSlider();
      await getSocialMedia();
      await getListDasarHukum();
      getTahun();
    });

    const listSocialMedia = ref([]);
    const getSocialMedia = async () => {
      const params = {
        status: 1,
      };
      await cmsStore
        .getSocialMedia(params)
        .then((res) => {
          listSocialMedia.value = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const listDasarHukum = ref([]);

    const queryParams = reactive({
      is_public: true,
      limit: 10,
      page: 1,
      sort: "asc",
      orderBy: "id",
      category_id: 1,
      keyword: "",
      tahun_terbit: "",
      status: "published",
    });
    const getListDasarHukum = async () => {
      await cmsStore
        .getRules(queryParams)
        .then((res) => {
          rulesList.value = res.data.data.data;
          rulesMeta.limit = res.data.data.limit;
          rulesMeta.offset = res.data.data.offset;
          rulesMeta.page = res.data.data.page;
          rulesMeta.total_data = res.data.data.total_data;
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const sort = async (sort: Sort) => {
      queryParams.sort = sort.order;
      queryParams.orderBy = sort.label ?? "sort";

      isLoading.value = true;
      await getListDasarHukum();
      isLoading.value = false;
    };

    const itemsPerPageChange = async (page: number) => {
      queryParams.limit = page;

      isLoading.value = true;
      await getListDasarHukum();
      isLoading.value = false;
    };

    const pageChange = async (page: number) => {
      queryParams.page = page;

      isLoading.value = true;
      await getListDasarHukum();
      isLoading.value = false;
    };

    const handleCategoryChange = async (event: any) => {
      queryParams.category_id = event.target.value;

      isLoading.value = true;
      await getListDasarHukum();
      isLoading.value = false;
    };

    const handleTahunChange = async (event: any) => {
      queryParams.tahun_terbit = event.target.value;

      isLoading.value = true;
      await getListDasarHukum();
      isLoading.value = false;
    };

    const search = ref<string>("");
    const searchItems = async () => {
      if (search.value !== "") {
        queryParams.keyword = search.value;
      } else {
        queryParams.keyword = "";
      }

      await getListDasarHukum();
    };

    const listTahun = ref([]);
    const getTahun = () => {
      const date = new Date();
      const tahun = date.getFullYear();
      const tahunAwal = tahun - 7;
      const tahunAkhir = tahun;

      for (let i = tahunAwal; i <= tahunAkhir; i++) {
        listTahun.value.push(i);
      }
    };

    return {
      cmsStore,
      listSocialMedia,
      listDasarHukum,
      getFilePath,
      loadingGallery,
      fomatDateTimeIndo,
      tableHeader,
      rulesList,
      rulesMeta,
      isLoading,
      queryParams,
      sort,
      itemsPerPageChange,
      pageChange,
      handleCategoryChange,
      handleTahunChange,
      search,
      searchItems,
      listTahun,
    };
  },
});
</script>


<style scoped>
.demo-image__error .image-slot {
  font-size: 30px;
}
.demo-image__error .image-slot .el-icon {
  font-size: 30px;
}
.demo-image__error .el-image {
  width: 100%;
  height: 300px;
}

.timeline-steps {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.timeline-steps .timeline-step {
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 1rem;
}

@media (min-width: 768px) {
  .timeline-steps .timeline-step:not(:last-child):after {
    content: "";
    display: block;
    border-top: 0.25rem dotted #fff;
    width: 3.46rem;
    position: absolute;
    left: 7.5rem;
    top: 0.3125rem;
  }
  .timeline-steps .timeline-step:not(:first-child):before {
    content: "";
    display: block;
    border-top: 0.25rem dotted #fff;
    width: 3.8125rem;
    position: absolute;
    right: 7.5rem;
    top: 0.3125rem;
  }
}

.timeline-steps .timeline-content {
  width: 10rem;
  text-align: center;
}

.timeline-steps .timeline-content .inner-circle {
  border-radius: 1.5rem;
  height: 1rem;
  width: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}

.timeline-steps .timeline-content .inner-circle:before {
  content: "";
  background-color: #fff;
  display: inline-block;
  height: 3rem;
  width: 3rem;
  min-width: 3rem;
  border-radius: 6.25rem;
  opacity: 0.5;
}
</style>